import React from "react";
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';

import { whereBallsMove, getHeader } from "../../helper";
import checked from "../../images/checked-big.png";

class InvoiceSuccess extends React.Component {

    constructor(props) {
        super(props);

        const params = new URLSearchParams(window.location.search.substring(1));
        this.out_summ = params.get('out_summ') || null;
    }

    componentDidMount() {
        document.title = 'Fixfact';
        whereBallsMove(5);
    }

    render() {

        return (
            <div className="vertical-scrolling page firstSection sectionHome" id="sectionHome" data-main-nav-id="homeNavLink">
                <div className="container content">

                    <div className="left-content left-content-width error-block">
                    </div>

                    <div className="right-content right-content-out right-content-width">
                        <div className="screen-outer-block-wrap native-scroll">
                            <div className="rounded-white-block screen-bottom-block">
                                <div
                                    className="white-block-top header-tabs tab-nav"
                                    style={{padding: '30px', flexDirection:'column', alignItems: 'center'}}>

                                    <div className="invoice-image-sprite">
                                        <img src={checked} className="invoice-image"/>
                                    </div>

                                    <h2 className="invite-title">
                                        Поздравляем!
                                    </h2>
                                    <h3 className="invite-title">
                                        {`Пополнение кошелька прошло успешно на сумму ${this.out_summ} руб.`}
                                    </h3>

                                    <div style={{flexDirection:'row', display:'flex', marginTop: '20px'}}>
                                        <div
                                            className="button-action big-button violet-button-gradient"
                                            style={{marginLeft:'10px'}}
                                            >
                                            <Link
                                                to={`/`}
                                                className="button-action big-button violet-button-gradient"
                                                >
                                                <button
                                                    style={{paddingLeft: '20px', paddingRight:'20px'}}
                                                    className={false ? 'disabled' : ''}
                                                    >
                                                    На главную страницу
                                                </button>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
	state => ({
		session: state.session
	})
)(InvoiceSuccess);


// WEBPACK FOOTER //
// ./src/components/Invoice/InvoiceSuccess.js